import { helloUser } from '../../../../../img/images';
import { ILocalization } from '../../../../../localization/definitions/types';

export const HelloUserSlideImage = () => {
    return (
        <div className='carousel-img w-100 h-100'>
            <div className='hello-user-slide'></div>
        </div>
    );
};

export const HelloUserSlideImageSrc = helloUser;

interface Props {
    localization: ILocalization;
}

export const HelloUserSlideContent = ({ localization }: Props) => {
    const { helloUserSlide } =
        localization.localizationStrings.susy.thesisManagement.tutorial.user
            .slides;

    return (
        <div
            data-testid='first-slide'
            className='tutorial-content-wrapper hello-user-slide-content'
        >
            <h1>{helloUserSlide.helloMyName}​</h1>
            <h4>{helloUserSlide.imYourNewSystem}</h4>
            <div className='instruction-row'>
                <div className='instruction-content'>
                    {helloUserSlide.myJob}
                </div>
            </div>
        </div>
    );
};
